import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { TrackingConsentDirective } from './change-consent.directive';
import * as i0 from "@angular/core";
export let TrackingChangeConsentButtonComponent = /*#__PURE__*/(() => {
  class TrackingChangeConsentButtonComponent {
    static {
      this.ɵfac = function TrackingChangeConsentButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TrackingChangeConsentButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: TrackingChangeConsentButtonComponent,
        selectors: [["ng-component"]],
        decls: 1,
        vars: 0,
        consts: [["e2e-change-privacy-settings", "", "uiButton", "", "label", "Datenschutzeinstellungen \u00E4ndern", "trackingChangeConsent", "", 1, "ui-button-grey", "small", "change-privacy"]],
        template: function TrackingChangeConsentButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "button", 0);
          }
        },
        dependencies: [UiButtonComponent, TrackingConsentDirective],
        styles: [".change-privacy[_ngcontent-%COMP%]{float:right;margin-bottom:15px}\n\n/*# sourceMappingURL=change-consent-button.component.ts-angular-inline--57.css.map*/"]
      });
    }
  }
  return TrackingChangeConsentButtonComponent;
})();